import React from 'react'

const STYLE_ID = 'spinner-shim-keyframes'

if (typeof document !== 'undefined' && !document.getElementById(STYLE_ID)) {
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = '@keyframes sk-doubleBounce{0%,100%{transform:scale(0)}50%{transform:scale(1)}}'
  document.head.appendChild(style)
}

export default function Spinner ({ style = {} }) {
  const size = style.width || '40px'
  const { width: _w, height: _h, ...restStyle } = style
  const wrapper = {
    position: 'relative',
    margin: '0 auto',
    flexShrink: 0,
    ...restStyle,
    width: size,
    height: size,
  }
  const dot = {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: '#333',
    opacity: 0.6,
    position: 'absolute',
    top: 0,
    left: 0,
    animation: 'sk-doubleBounce 2s infinite ease-in-out',
  }
  return (
    <div style={wrapper}>
      <div style={dot} />
      <div style={{ ...dot, animationDelay: '-1s' }} />
    </div>
  )
}
